/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceOwnerDto } from "./DeviceOwnerDto";
import {
    DeviceOwnerDtoFromJSON,
    DeviceOwnerDtoFromJSONTyped,
    DeviceOwnerDtoToJSON,
} from "./DeviceOwnerDto";

/**
 *
 * @export
 * @interface UserAccountDto
 */
export interface UserAccountDto {
    /**
     *
     * @type {number}
     * @memberof UserAccountDto
     */
    userAccountId?: number;
    /**
     *
     * @type {string}
     * @memberof UserAccountDto
     */
    userType?: UserAccountDtoUserTypeEnum;
    /**
     *
     * @type {string}
     * @memberof UserAccountDto
     */
    accountStatus?: UserAccountDtoAccountStatusEnum;
    /**
     *
     * @type {string}
     * @memberof UserAccountDto
     */
    identityProvider?: string;
    /**
     *
     * @type {string}
     * @memberof UserAccountDto
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof UserAccountDto
     */
    username?: string;
    /**
     *
     * @type {string}
     * @memberof UserAccountDto
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof UserAccountDto
     */
    mobileNo?: string;
    /**
     *
     * @type {Date}
     * @memberof UserAccountDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof UserAccountDto
     */
    updatedAt?: Date;
    /**
     *
     * @type {DeviceOwnerDto}
     * @memberof UserAccountDto
     */
    deviceOwner?: DeviceOwnerDto;
    /**
     *
     * @type {Array<string>}
     * @memberof UserAccountDto
     */
    roles?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof UserAccountDto
     */
    deviceGroupTags?: Array<string>;
    /**
     *
     * @type {string}
     * @memberof UserAccountDto
     */
    organisationId?: string;
    /**
     *
     * @type {number}
     * @memberof UserAccountDto
     */
    parentUserAccountId?: number;
}

/**
 * @export
 */
export const UserAccountDtoUserTypeEnum = {
    Unknown: "Unknown",
    EnterpriseUser: "EnterpriseUser",
    EndUser: "EndUser",
    ApiUser: "ApiUser",
    Driver: "Driver",
} as const;
export type UserAccountDtoUserTypeEnum =
    (typeof UserAccountDtoUserTypeEnum)[keyof typeof UserAccountDtoUserTypeEnum];

/**
 * @export
 */
export const UserAccountDtoAccountStatusEnum = {
    Invited: "Invited",
    Pending: "Pending",
    Active: "Active",
    Suspended: "Suspended",
    Closed: "Closed",
} as const;
export type UserAccountDtoAccountStatusEnum =
    (typeof UserAccountDtoAccountStatusEnum)[keyof typeof UserAccountDtoAccountStatusEnum];

/**
 * Check if a given object implements the UserAccountDto interface.
 */
export function instanceOfUserAccountDto(
    value: object,
): value is UserAccountDto {
    return true;
}

export function UserAccountDtoFromJSON(json: any): UserAccountDto {
    return UserAccountDtoFromJSONTyped(json, false);
}

export function UserAccountDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UserAccountDto {
    if (json == null) {
        return json;
    }
    return {
        userAccountId:
            json["userAccountId"] == null ? undefined : json["userAccountId"],
        userType: json["userType"] == null ? undefined : json["userType"],
        accountStatus:
            json["accountStatus"] == null ? undefined : json["accountStatus"],
        identityProvider:
            json["identityProvider"] == null
                ? undefined
                : json["identityProvider"],
        name: json["name"] == null ? undefined : json["name"],
        username: json["username"] == null ? undefined : json["username"],
        email: json["email"] == null ? undefined : json["email"],
        mobileNo: json["mobileNo"] == null ? undefined : json["mobileNo"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        deviceOwner:
            json["deviceOwner"] == null
                ? undefined
                : DeviceOwnerDtoFromJSON(json["deviceOwner"]),
        roles: json["roles"] == null ? undefined : json["roles"],
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        parentUserAccountId:
            json["parentUserAccountId"] == null
                ? undefined
                : json["parentUserAccountId"],
    };
}

export function UserAccountDtoToJSON(value?: UserAccountDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        userAccountId: value["userAccountId"],
        userType: value["userType"],
        accountStatus: value["accountStatus"],
        identityProvider: value["identityProvider"],
        name: value["name"],
        username: value["username"],
        email: value["email"],
        mobileNo: value["mobileNo"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        deviceOwner: DeviceOwnerDtoToJSON(value["deviceOwner"]),
        roles: value["roles"],
        deviceGroupTags: value["deviceGroupTags"],
        organisationId: value["organisationId"],
        parentUserAccountId: value["parentUserAccountId"],
    };
}
